import { useState, useEffect } from "react";

import Cancelled from "../../../../components/Engage/CancelledV2";
import Loading from "../../../../components/Shared/Loading";
function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}

export default function MinuteDetails() {
  const isMounted = useMounted();

  return (
    <div className="h-screen flex overflow-hidden bg-white">
      {isMounted ? (
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <Cancelled />
        </main>
      ) : (
        <Loading />
      )}
    </div>
  );
}
